import React, { forwardRef, useEffect, useState } from 'react';
// import Picture from '@components/Picture';
import { Picture } from '@ui';
import './index.scss';
import type { IconType } from '@root/src/types';
import { twcls } from '@utils/twcls';

interface IconTextProps {
  text;
  withCursor?: boolean;
  marginRight?: string | number;
  iconHover?: IconType;
  hoveredTextClassName?: string;
  color?: string;
  hoverColor?: string;
  icon?: IconType;
  height?: string;
  fontBold?: boolean;
  fontMedium?: boolean;
  fontSize?: string;
  className?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
  marginBottom?: string | number;
}

const IconText = forwardRef<HTMLDivElement, IconTextProps>(
  (
    {
      text,
      withCursor,
      marginRight,
      iconHover,
      hoveredTextClassName,
      color,
      hoverColor,
      icon,
      height,
      fontBold,
      fontMedium,
      fontSize = '12',
      className = '',
      onClick,
      style,
      marginBottom
    },
    ref
  ) => {
    const [imgSrc, setImgSrc] = useState(icon);
    const [isHovered, setIsHovered] = useState(false);
    useEffect(() => {
      setImgSrc(icon);
    }, [icon]);
    const onMouseEnter = (): void => {
      setImgSrc(iconHover);
      setIsHovered(true);
    };
    const onMouseLeave = (): void => {
      setImgSrc(icon);
      setIsHovered(false);
    };

    const styleNew = {
      ...style
    };
    if (marginBottom) {
      styleNew.marginBottom = marginBottom;
    }
    return (
      <div
        ref={ref}
        onMouseEnter={iconHover ? onMouseEnter : undefined}
        style={styleNew}
        onMouseLeave={iconHover ? onMouseLeave : undefined}
        onClick={onClick}
        className={twcls(
          'IconText',
          color && `IconText--clr-${color}`,
          fontSize && `IconText--fs-${fontSize}`,
          hoverColor && ` IconText--withHover-${hoverColor}`,
          onClick && ' IconText--hover',
          fontBold && ' IconText--bold',
          withCursor && ' IconText--with-cursor',
          fontMedium && ' IconText--medium',
          className
        )}
      >
        {icon && (
          <Picture
            pictureClassName='IconText__picture'
            className={`IconText__icon${
              marginRight ? ` IconText__icon--mr-${marginRight}` : ''
            }`}
            icon={imgSrc}
            height={height}
          />
        )}
        <div
          className={`IconText__text ${
            isHovered && hoveredTextClassName ? hoveredTextClassName : ''
          }`}
        >
          {text}
        </div>
      </div>
    );
  }
);

export default IconText;
